import { Add } from "@mui/icons-material";
import { Grid } from "@mui/material";

import Box from "../../components/Box";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import RoleService, { IRequestGetPagedRole } from "../../services/identity/role.serice";

import { useState } from "react";
import { ICodename, IPropListContainer } from "../../commons/interfaces";
import { RoleHelpers } from "../../commons/roleHelpers";
import { Mode, RoleTab, RoleType } from "../../constants/enums";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { IRequestGetPagedPolicy } from "../../services/identity/policy.service";
import { MainComponent } from "../main";
import PolicyListComponent from "./list/PolicyList";
import RoleListComponent from "./list/RoleList";
import RoleTabComponent from "./roleTab";
import Helpers from "../../commons/helpers";

export const commonGetAllDataRole = async (params: {
    type?: string;
    status?: number;
    clientId?: string;
    roleLevel?: string;
    serviceCode?: string;
    organizationId?: string;
}) => {
    try {
        const roleListTemp: ICodename[] = [];
        const result = await RoleService.getAll({
            type: params.type,
            status: params.status,
            clientId: params.clientId,
            roleLevel: params.roleLevel,
            serviceCode: params.serviceCode,
            organizationId: params.organizationId,
        });

        [...(result || [])].forEach((e: any) => {
            let groupName = "";

            if (e?.organizationId === "0" ||
                Number(e?.organizationId) === 0 ||
                Helpers.isNullOrEmpty(e?.organizationId)
            ) {
                groupName = "Mặc định";
            } else {
                groupName = "Bổ sung";
            }

            roleListTemp.push({
                name: e.roleName,
                code: e.roleCode,
                group: groupName,
                detail: {
                    roleType: e.type,
                    roleLevel: e.roleLevel,
                },
            });
        });

        return roleListTemp;
    } catch (error) {
        return [];
    }
};

const RoleListContainer = ({
    hidenActionCreate,
    hidenActionDelete,
    hidenActionUpdate,
    hiddenTab,
    requestGetPaged,
    onGetPaged,
    onNavigate,
}: IPropListContainer<IRequestGetPagedRole | IRequestGetPagedPolicy> & {
    hidenActionUpdate?: boolean;
    hidenActionDelete?: boolean;
    hidenActionCreate?: boolean;
    hiddenTab?: boolean;
}) => {
    const Strings = useStrings();
    const { userInfo, serviceCode } = useCommonComponentContext();

    const [selectedTab, setSelectedTab] = useState<RoleTab>(RoleTab.Role);

    const { roleDetailType } = RoleHelpers.getRole(userInfo?.userProfile?.roleType);

    return (
        <MainComponent>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: hiddenTab ? "right" : "space-between", width: "100%" }}>
                        {!hiddenTab && <RoleTabComponent tab={selectedTab} setTab={setSelectedTab} backgroundColor="transparent" />}
                        {!hidenActionCreate && roleDetailType > RoleType.Custom && (
                            <Button
                                onClick={() => {
                                    onNavigate({ mode: Mode.Create });
                                }}
                            >
                                <Add /> &nbsp;
                                {Strings.Common.ADD_NEW}
                            </Button>
                        )}
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {selectedTab === RoleTab.Role && (
                        <RoleListComponent
                            {...{ onGetPaged, onNavigate, requestGetPaged, hidenActionCreate, hidenActionDelete, hidenActionUpdate }}
                        />
                    )}
                    {selectedTab === RoleTab.Policy && (
                        <PolicyListComponent
                            {...{ onGetPaged, onNavigate, requestGetPaged, hidenActionCreate, hidenActionDelete, hidenActionUpdate }}
                        />
                    )}
                </Grid>
            </Grid>
        </MainComponent>
    );
};

export default RoleListContainer;
